/**
 * AboutSLAboutAnalyticsView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AboutSLAboutAnalytics
 */

import { useAboutSLAboutAnalyticsLogic } from '@/hooks/traits/useAboutSLAboutAnalyticsLogic';
import type { AboutSLAboutAnalyticsConfig } from '@/hooks/traits/useAboutSLAboutAnalyticsLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AboutSLAnalyticsRecord } from '@app/shared';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AboutSLAboutAnalyticsViewProps {
  config?: Partial<AboutSLAboutAnalyticsConfig>;
}

export function AboutSLAboutAnalyticsView({ config: propsConfig }: AboutSLAboutAnalyticsViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAboutSLAboutAnalyticsLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AboutSLAnalyticsRecord'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AboutSL" trait="AboutSLAboutAnalytics">
      <UISlotComponent slot="system" pattern={slotWriter['system'] === 'INIT' ? "typography" : slotWriter['system'] === 'REPORTED' ? "typography" : slotWriter['system'] === 'REPORT_FAILED' ? "typography" : "clear"} sourceTrait="AboutSLAboutAnalytics">{slotWriter['system'] === 'INIT' ? (<Typography content="Reporting this visit…" role="status" variant="caption" />) : slotWriter['system'] === 'REPORTED' ? (<Typography content={(lastPayload?.sent) ? "Visit reported" : "Not reported here"} role="status" variant="caption" />) : slotWriter['system'] === 'REPORT_FAILED' ? (<Typography role="status" content={renderPatternValue(["Not reported: ", lastPayload?.error].join(''))} variant="caption" />) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AboutSLAboutAnalyticsView;
